import { createApp } from 'vue';
import router from './router.js';
import App from './App.vue';
import BaseButton from './components/UI/BaseButton.vue';
import { createStore } from 'vuex';
import VueTelInput from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import IdleVue from 'idle-vue';
import i18n from './i18n';

const app = createApp(App).use(i18n);

const store = createStore({
  state() {
    return {
      email: null,
      phoneNumber: null,
      interestedLanguages: null,
      selectedLanguages: null,
      profession: null,
    };
  },
});

const VueTelInputOptions = {
  mode: 'international',
};

const options = { store, idleTime: 29000 };

app.component('base-button', BaseButton);
app.component(VueTelInput, VueTelInputOptions);

app.use(router);
app.use(store);

app.use(IdleVue, options);
app.mount('#app');
